import { render, staticRenderFns } from "./MemberOpportunitiesTab.vue?vue&type=template&id=82663802&"
import script from "./MemberOpportunitiesTab.vue?vue&type=script&lang=js&"
export * from "./MemberOpportunitiesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports